import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrIconModule } from '@app/components/pr-icon/pr-icon.module';
import { PrButtonAddComponent } from './pr-button-add.component';

@NgModule({
  declarations: [PrButtonAddComponent],
  imports: [CommonModule, PrIconModule],
  exports: [PrButtonAddComponent],
})
export class PrButtonAddModule {}
